import { IconButton } from '@mui/material';
import { GridColDef, getGridStringOperators } from '@mui/x-data-grid-pro';

import { IcDotSpread } from '@/assets/images';
import { excludeValues } from '@/components/DataGrid/utils';
import { IUnitType } from '@/models';

const name = (): Partial<GridColDef> => ({
  filterOperators: getGridStringOperators().filter(
    excludeValues(['isAnyOf', 'isNotEmpty', 'isEmpty']),
  ),
  flex: 1,
  minWidth: 600,
});

const actions = (
  openMenu?: (
    event: React.MouseEvent<HTMLButtonElement>,
    param: IUnitType,
  ) => void,
): Partial<GridColDef> => ({
  sortable: false,
  filterable: false,
  renderCell: (params) => {
    return (
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          openMenu?.(e, params.row);
        }}
      >
        <IcDotSpread />
      </IconButton>
    );
  },
});

export const unitTypeCols = (
  openMenu?: (
    event: React.MouseEvent<HTMLButtonElement>,
    param: IUnitType,
  ) => void,
) => {
  return {
    name,
    actions: () => actions(openMenu),
  };
};
